import { render, staticRenderFns } from "./ToolboxTalkDetails.vue?vue&type=template&id=38825eda&scoped=true"
import script from "./ToolboxTalkDetails.vue?vue&type=script&lang=ts"
export * from "./ToolboxTalkDetails.vue?vue&type=script&lang=ts"
import style0 from "./ToolboxTalkDetails.vue?vue&type=style&index=0&id=38825eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38825eda",
  null
  
)

export default component.exports